import { render, staticRenderFns } from "./ClientAccountingCategory.vue?vue&type=template&id=2b37e6bb&"
import script from "./ClientAccountingCategory.vue?vue&type=script&lang=js&"
export * from "./ClientAccountingCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports